import { FC } from 'react';

import {
  ToastsStackProvider,
  ToastsStackProviderProps,
} from '@material-bank/mb-uikit/shared/components/ToastsStackProvider';

import * as styles from './styles';

export interface ToastsProvider extends ToastsStackProviderProps {
  enabled?: boolean;
}

export const ToastsProvider: FC<ToastsProvider> = (props) => {
  const { enabled = true, children, ...toastsProviderProps } = props;

  if (!enabled) {
    return <>{children}</>;
  }

  return (
    <ToastsStackProvider
      expandedStack
      {...toastsProviderProps}
      viewportSx={styles.viewport}
    >
      {children}
    </ToastsStackProvider>
  );
};
